import type { Container } from "inversify"
import { computed } from "mobx"
import type { IAuthService } from "services/authService"
import type { ILanguageService } from "services/languageService"
import { TYPES } from "services/types"

export class FooterContentViewModel {
  private authService: IAuthService

  constructor(private readonly container: Container) {
    this.authService = container.get<IAuthService>(TYPES.IAuthService)
  }

  @computed
  get language() {
    return this.container.get<ILanguageService>(TYPES.ILanguageService).language
  }

  public getAgreementPDF() {
    return this.authService.getPrivacyPolicyURL(this.language)
  }
}
